'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _matchesSelector = require('../../../common/matchesSelector');

var _matchesSelector2 = _interopRequireDefault(_matchesSelector);

var _containsNode = require('../../../common/containsNode');

var _containsNode2 = _interopRequireDefault(_containsNode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Checks if node matches target, it mathces if:
 * - it is the same element
 * - is a string and matches the selector
 * (target: String, node: HtmlElement) => Bool
 */
/**
 * Copyright (c) 2015-present, Zippy Technologies
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function matchesTarget(target, node) {
  if (node === document) {
    return null;
  }

  if (target === node) {
    return true;
  }

  if (typeof target === 'string' && (0, _matchesSelector2.default)(node, target)) {
    return true;
  }

  if ((0, _containsNode2.default)(target, node)) {
    return true;
  }

  return false;
}

exports.default = matchesTarget;